<app-toast></app-toast>
<ng-http-loader></ng-http-loader>
<div class="w-full bg-gray-50 flex flex-col font-sans overflow-hidden text-gray-800" style="height:100dvh">
    @if (!sessionService.isLoggedIn()) {
        <app-login />
    }
    @else
    {
        <app-header />
        <main class="flex-1 overflow-y-auto overflow-x-hidden relative scroll-smooth bg-gray-50">
            <div class="max-w-4xl mx-auto min-h-full">
                <router-outlet />
            </div>
        </main>
        <app-footer />
    }
</div>